import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'lilu-heading',
  styleUrl: 'lilu-heading.scss',
  shadow: true,
})
export class LiluHeading {
  @Prop() tooltip?: string;
  @Prop() level = '1';
  @Prop() color?: string = 'nero';
  @Prop() colorcode?: string;
  @Prop() size = '';
  @Prop() url = '';
  @Prop() fontWeight? = 'bold';
  @Prop() ellipsis = false;

  renderTextColor = () => {
    return { color: this.colorcode };
  };

  getCustomTag() {
    const CustomTag = `h${this.level}`;

    return (
        <CustomTag class={`heading ${this.fontWeight} ${this.color} ${this.size ? `size ${this.size}` : ''} ${this.ellipsis ? 'ellipsis' : ''}`} style={this.colorcode ? this.renderTextColor() : null}>
        <slot></slot>
        {this.tooltip &&
          <lilu-tooltip class="tooltip" content={this.tooltip}>
            <lilu-icon slot="icon" size="size-14 lg-size-16" color="nero" type="icon-info"></lilu-icon>
          </lilu-tooltip>
        }
        </CustomTag>
    );
  }

  render() {
    return (
      <Host class={`${this.size}`}>
        { this.url !== ''?
            <a href={`${this.url}`}>
              {this.getCustomTag()}
            </a>
            :
            this.getCustomTag()
        }
      </Host>
    );
  }
}
